import React from 'react';
import { Link } from 'react-router-dom';

export default function Cta() {
    return (
        <section className="cta-section">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="cta-conetnt">
                            <div className="cta-logo">
                                <img src="assets/images/cta-logo.png" alt="" />
                            </div>
                            <h5>Call us 24/7</h5>
                            <h2>545-75797-897</h2>
                            <Link to="/contact" className="theme-btn-s3">Make An Appointment</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}